import { EContactType, Meta } from 'types/common';
import { EnumFields } from 'types/enumerationData';
import { PATH } from './path';
import dayjs from 'utils/dayjs';
import { EInvitedProviderStep } from 'pages/InvitedProviderOnboarding/steps';

export const PPA_STEP_LABEL: Record<string, string> = {
    STEP_1: 'Create Profile - Welcome',
    STEP_2: 'Create Profile - Name',
    STEP_3: 'Create Profile - Credentials',
    STEP_4: 'Create Profile - Gender',
    STEP_5: 'Service Setup - Intro',
    STEP_6: 'Service Setup - Specialty',
    STEP_7: 'Service Setup - Payment Method',
    STEP_8: 'Service Setup - Visit Details',
    STEP_9: 'List on Klarity - Intro',
    STEP_10: 'List on Klarity - Showcase',
    STEP_11: 'List on Klarity - Government ID Upload',
    STEP_12: 'List on Klarity - Medical License Upload',
    STEP_13: 'List on Klarity - Payment Info',
    STEP_14: 'Availability - Intro',
    STEP_15: 'Availability - Working Hours',
    STEP_16: 'Availability - Advance Notice',
    STEP_17: 'Availability - Consent Forms',
    STEP_17_1: 'Availability - Consent Forms Confirm',
    STEP_18: 'Review',
    STEP_19: 'Basic - Finish',
    STEP_20: 'Advanced Settings',
    STEP_21: 'Advanced Settings - Complete',
    [EInvitedProviderStep.CREATE_PROFILE_CREDENTIALS]: 'Invited - Create Profile - Credentials',
    [EInvitedProviderStep.CREATE_PROFILE_GENDER]: 'Invited - Create Profile - Gender',
    [EInvitedProviderStep.SETUP_SERVICES_SPECIALTY]: 'Invited - Service Setup - Specialty',
    [EInvitedProviderStep.SETUP_SERVICES_PAYMENT]: 'Invited - Service Setup - Payment Method',
    [EInvitedProviderStep.SETUP_SERVICES_TEMPLATE]: 'Invited - Service Setup - Visit Details',
    [EInvitedProviderStep.MARKETING_PERSONAL_ID]: 'Invited - Marketing - Personal ID',
    [EInvitedProviderStep.MARKETING_MEDICAL_LICENSE]: 'Invited - Marketing - Medical License',
    [EInvitedProviderStep.AVAILABILITY_WORKING_HOURS]: 'Invited - Availability - Working Hours',
    [EInvitedProviderStep.AVAILABILITY_ADVANCE_NOTICE]: 'Invited - Availability - Advance Notice',
    [EInvitedProviderStep.REVIEW]: 'Invited - Review',
    [EInvitedProviderStep.GO_LIVE]: 'Invited - Go Live',
    [EInvitedProviderStep.ADVANCE_SETTING]: 'Invited - Advanced Settings',
    [EInvitedProviderStep.COMPLETED]: 'Invited - Completed',
};

export const getAskChartDemoUrl = () => {
    return 'https://form.typeform.com/to/zomJWM1Y';
    // const month = dayjs().add(1, 'day').format('YYYY-MM');
    // return `https://calendly.com/d/cvtm-3nr-zzq/askchart-1-1-demo?month=${month}`;
};

export const isLocalhost = () => {
    const check =
        window.location.hostname.includes('localhost') ||
        window.location.hostname.includes('127.0.0.1') ||
        window.location.hostname.includes('.168');
    return !!check;
};

export const isTestEnv = () => {
    const check = window.location.hostname.includes('test.');

    return !!check;
};

export const isDevEnv = () => {
    const check = window.location.hostname.includes('dev.') || isLocalhost();

    return !!check;
};

enum EBillingStatus {
    DISPUTE_OPEN = 'DISPUTE_OPEN',
    // DISPUTE_CLOSED = "DISPUTE_CLOSED",
    PENDING = 'PENDING',
    NOT_READY = 'NOT_READY',
    // PAID = "PAID",
    FAILED = 'FAILED',
    CANCELED = 'CANCELLED',
    // billing rows spell it with one L; CANCELED above is the invoice status
    BILLING_CANCELED = 'CANCELED',
    // NOT_READY = "NOT_READY",
    PROCESSING = 'PROCESSING',
    SUCCEEDED = 'SUCCEEDED',
    REFUND_PROCESSING = 'REFUNDED_PROCESSING',
    REFUNDED = 'REFUNDED',
    REFUND_FAILED = 'REFUNDED_FAILED',
    DISPUTE_PROCESSING = 'DISPUTE_PROCESSING',
    DISPUTE_WON = 'DISPUTE_WON',
    DISPUTE_LOST = 'DISPUTE_LOST',
    PATIENT_NOT_READY = 'PATIENT_NOT_READY',
    PROVIDER_NOT_READY = 'PROVIDER_NOT_READY',

    // invoice
    SCHEDULED = 'SCHEDULED',
    SENT = 'SENT',
    PARTIAL_PAID = 'PARTIAL_PAID',
    FULLY_PAID = 'FULLY_PAID',
    PARTIAL_REFUNDED = 'PARTIAL_REFUNDED',
    OVERDUE = 'OVERDUE',
}

enum EAddOnProductCode {
    SELF_EPRESCRIPTION_EPCS = 'ADD-ON-P001',
    SELF_EPRESCRIPTION = 'ADD-ON-P002',
    SELF_EFAX = 'ADD-ON-P003',
    COLLABORATING_PHYSICIAN_SEAT = 'ADD-ON-P004',
    COLLABORATING_PHYSICIAN_EPRESCRIPTION_EPCS = 'ADD-ON-P005',
    COLLABORATING_PHYSICIAN_EPRESCRIPTION = 'ADD-ON-P006',
    ASSISTANT_SEAT = 'ADD-ON-P007',
    ASSISTANT_EPRESCRIPTION_EPCS = 'ADD-ON-P008',
    ASSISTANT_EPRESCRIPTION = 'ADD-ON-P009',
}

export const DEFAULT_SECOND_TYPE = '1';
export const GOOGLE_ADMIN_URL = 'https://admin.google.com/ac/users';

export const DURATION_LIST = (() => {
    const ret = [];
    for (let i = 0; i <= 90; i += 5) {
        ret.push({
            label: `${i}`,
            value: i,
        });
    }
    return ret;
})();
export const ERROR_CODE = {
    TOKEN_UN_VERIFY: 4001,
    // Staff login succeeded on credentials but found no provider to auto-land on.
    // Actionable for the user ("contact the practice admin"), so the backend message
    // must be surfaced verbatim rather than collapsed into the generic password copy.
    STAFF_NO_PROVIDER_SCOPE: 4004,
};

export const CHANNEL_APPOINTMENT_STEP_SESSIONSTORAGE_KEY = 'channelAppointmentStep';

export const INTAKEFORM_CREATE_URL = 'https://intakeq.com/#/myforms';

//冬令时区
export const WINTER_TIME_ZONE = [
    {
        dictKey: 'Africa/Freetown',
        offset: '-00',
        label: '(UTC+00:00) Greenwich Time Zone',
    },
    {
        dictKey: 'America/Thule',
        offset: '-04',
        label: '(UTC-04:00) Atlantic Time Zone',
    },
    {
        dictKey: 'America/New_York',
        offset: '-05',
        label: '(UTC-05:00) Eastern Time Zone',
    },
    {
        dictKey: 'America/Chicago',
        offset: '-06',
        label: '(UTC-06:00) Central Time Zone',
    },
    {
        dictKey: 'America/Denver',
        offset: '-07',
        label: '(UTC-07:00) Mountain Time Zone',
    },
    {
        dictKey: 'America/Phoenix',
        offset: '-07',
        label: '(UTC-07:00) Mountain Standard Time Zone',
    },
    {
        dictKey: 'America/Los_Angeles',
        offset: '-08',
        label: '(UTC-08:00) Pacific Time Zone',
    },
    {
        dictKey: 'America/Anchorage',
        offset: '-09',
        label: '(UTC-09:00) Alaska Time Zone',
    },
    {
        dictKey: 'America/Adak',
        offset: '-10',
        label: '(UTC-10:00) Hawaii-Aleutian Time Zone',
    },
    {
        dictKey: 'Asia/Shanghai',
        offset: '+08',
        label: '(UTC+08:00) China Time Zone',
    },
];

//夏令时区
export const SUMMER_TIME_ZONE = [
    {
        dictKey: 'Africa/Freetown',
        offset: '-00',
        label: '(UTC+00:00) Greenwich Time Zone',
    },
    {
        dictKey: 'America/Thule',
        offset: '-03',
        label: '(UTC-03:00) Atlantic Time Zone',
    },
    {
        dictKey: 'America/New_York',
        offset: '-04',
        label: '(UTC-04:00) Eastern Time Zone',
    },
    {
        dictKey: 'America/Chicago',
        offset: '-05',
        label: '(UTC-05:00) Central Time Zone',
    },
    {
        dictKey: 'America/Denver',
        offset: '-06',
        label: '(UTC-06:00) Mountain Time Zone',
    },
    {
        dictKey: 'America/Phoenix',
        offset: '-07',
        label: '(UTC-07:00) Mountain Standard Time Zone',
    },
    {
        dictKey: 'America/Los_Angeles',
        offset: '-07',
        label: '(UTC-07:00) Pacific Time Zone',
    },
    {
        dictKey: 'America/Anchorage',
        offset: '-08',
        label: '(UTC-08:00) Alaska Time Zone',
    },
    {
        dictKey: 'America/Adak',
        offset: '-09',
        label: '(UTC-09:00) Hawaii-Aleutian Time Zone',
    },
    {
        dictKey: 'Asia/Shanghai',
        offset: '+08',
        label: '(UTC+08:00) China Time Zone',
    },
];

// 夏令时判断：
// 如果当前日期晚于或等于3月第二个周日，并且早于11月第一个周日，则是夏令时
const isSummerTime = (): boolean => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-11，0 为一月
    const day = date.getDate();

    // 计算3月第二个周日的日期
    const marchSecondSunday = new Date(year, 2, 1); // 3月1日
    const marchFirstDayOfWeek = marchSecondSunday.getDay(); // 0-6，0 为周日
    // 计算到第二个周日的偏移量
    const daysUntilSecondSunday = ((7 - marchFirstDayOfWeek) % 7) + 7;
    marchSecondSunday.setDate(1 + daysUntilSecondSunday);

    // 计算11月第一个周日的日期
    const novemberFirstSunday = new Date(year, 10, 1); // 11月1日
    const novemberFirstDayOfWeek = novemberFirstSunday.getDay();
    // 计算到第一个周日的偏移量
    const daysUntilFirstSunday = (7 - novemberFirstDayOfWeek) % 7;
    novemberFirstSunday.setDate(1 + daysUntilFirstSunday);

    // 创建当前日期的复制，但只保留年月日
    const today = new Date(year, month, day);

    return today >= marchSecondSunday && today < novemberFirstSunday;
};

export const SUPPORT_TIME_ZONE = isSummerTime() ? SUMMER_TIME_ZONE : WINTER_TIME_ZONE;

export const SINGLE_TYPE_SINGLE_SERVICE = 'SINGLE_TYPE_SINGLE_SERVICE';

export const TERMS_LINK = 'https://www.kiwihealth.com/terms-conditions';
export const PRIVACY_LINK = 'https://www.kiwihealth.com/privacy-policy';
export const HELP_LINK = 'https://support.kiwihealth.com/support';
export const UNIPROFILE = 'uniprofile';
export const PRACTICE_FRONT = 'practiceFront';
// 拥有preview 页面的channel id
export const PREVIEW_GOOGLE_NAME = 'Google';
export const PREVIEW_ZOCDOC_NAME = 'Zocdoc';
export const PREVIEW_YELP_NAME = 'Yelp Basic';
// about me的长度限制
export const IntroTextLength = 2000;
export const TreatmentPhilosophyTextLength = 800;

// practice front 锚点
export enum EmptyFields {
    WorkExperience = 'Work experience',
    Education = 'Education',
    MyPhilosophy = 'Treatment Methodology',
    SpecialtiesApproaches = 'Specialties & Approaches',
}

export const PRACTICE_FRONT_FROM = 'pf';
export const CHANNEL_DETAIL = 'channelDetail';
export const HOME = 'home';

export const PRE_LOGIN_PAGE = [PATH.HOME, `/${PATH.LOGIN}`, `/${PATH.PROVIDER_LOGIN}`];

export const EMPTY_PLACEHOLDER = 'Not provided';
export const EMPTY_PLACEHOLDER_WITH_DASH = '-';
export const NOT_SET = 'Not set';
export const REQUIRED_FIELD = 'This field is required';

export const INSURANCE_TYPE_CASH = 'CASH';
export const INSURANCE_TYPE_INSURANCE = 'INSURANCE';
export const INSURANCE_TYPE_CASH_AND_INSURANCE = 'CASH_AND_INSURANCE';
export const PAY_TYPE_TEXT = {
    [INSURANCE_TYPE_CASH]: 'I only support cash pay.',
    [INSURANCE_TYPE_CASH_AND_INSURANCE]: 'I support both cash pay and insurance.',
    [INSURANCE_TYPE_INSURANCE]: 'I only accept insurance.',
};

// withdraw  页面应该是free对应free, paid对应到standard
// premium对应premium

export const ChannelPayTypeFilterMapKey = {
    standard: 'standard',
    premium: 'premium',
    free: 'free',
};

export const channelPayTypeFilterMap = {
    [ChannelPayTypeFilterMapKey.free]: ['free'],
    [ChannelPayTypeFilterMapKey.standard]: ['paid'],
    [ChannelPayTypeFilterMapKey.premium]: ['premium'],
};

export const DEFAULT_CHANNEL_LISTING_LIMITATION = {
    free: 2,
    standard: 6,
};

export const PAYMENT_WEBSITE_NAME = 'stripe';

export const CHANNEL_STORE = 'channelstore';
export const MY_CHANNELS = 'mychannels';

export const HTML_DIV_ID = {
    LOCAL_SEO_WRAP: 'localSeoWrap',
    PF_HOME_WRAP: 'pfHomeWrap',
};

export const PF_POI_AUTO_GEN_MAX_ACCOUNT = 10;

export const PATIENT_TEMPLATE_GOOGLE_DOC_URL =
    'https://docs.google.com/spreadsheets/d/1TYgCz_r7Z936YxkXLIUSIv1BJzopKnpVqAz92WxrDLo/edit#gid=0';

export const REVIEWS_TEMPLATE_GOOGLE_DOC_URL =
    'https://docs.google.com/spreadsheets/d/1NS_Z0OgSunTPNQqVWkM9TiPRa8KvMJ_sq0Ezik6SBJU/edit?gid=0#gid=0';

export const PF_CHANNEL_ID = 999999999;

export const OTHERS_CHANNEL_ID = -1;

export const PF_CHANNEL_NAME = 'Practice Front';

export const OTHERS_CHANNEL_NAME = 'Others';

export const UNIPROFILE_CREATION_ALISA = 'uc';

export const HELLO_KLARITY_PAGE_TYPE = [
    {
        label: 'Home',
        value: 'HOME',
    },
    {
        label: 'Condition',
        value: 'CONDITION',
    },
    {
        label: EnumFields.STATE,
        value: EnumFields.STATE,
    },
    {
        label: 'Faqs',
        value: 'FAQS',
    },
];

export const HelloKlarityProviderDraftStorageKey = 'HELLOKLARITY_PROVIDER_DRAFT_STORAGE';

// export const PRE_RELEASE_ORIGIN = isProductionEnv() ? 'https://prerelease.helloklarity.com' : '';
export const PRE_RELEASE_ORIGIN = '';

export const REQUIRE_FIELD_TIPS = 'This is a required field';
export const URL_LIMIT = 512;

export const HELP_EMAIL = 'onboarding@helloklarity.com';

export const CONTACT_TYPES_OPTIONS = [
    {
        label: EContactType.TELE_HEALTH,
        value: EContactType.TELE_HEALTH,
    },
    {
        label: EContactType.IN_PERSON,
        value: EContactType.IN_PERSON,
    },
];

export const PRESET_PATIENT_ACCEPTED = [
    'Children (5-12 years old)',
    'Adolescents (13-17 years old)',
    'Adults (18-65 years old)',
    'Seniors (65+ years old)',
    'Couples and family',
    'Group session',
];

export const PRESET_SERVICE_LIMITATIONS = [
    'Cannot see patients currently pregnant, nursing, or trying to conceive.',
    'Cannot treat patients with active suicidal behaviour or a history of suicide attempts or self-harm.',
    'Unable to see patients with recent mental health hospitalizations, legal holds (e.g., 5150/5250), or diagnosed personality disorders.',
    'Cannot see patients with certain medical conditions: heart issues, hypertension, or on medications like narcotics/opiates/Suboxone.',
    'Patients in addiction recovery must provide a confirmed sobriety date.',
    'Unable to treat patients diagnosed with eating disorders.',
];

export const SNAPSHOT_COLOR = '#1677ff';

export const AllState = [
    {
        id: 17,
        type: EnumFields.STATE,
        dictKey: 'AL',
        content: 'Alabama',
        description: null,
    },
    {
        id: 18,
        type: EnumFields.STATE,
        dictKey: 'AK',
        content: 'Alaska',
        description: null,
    },
    {
        id: 133,
        type: EnumFields.STATE,
        dictKey: 'AZ',
        content: 'Arizona',
        description: null,
    },
    {
        id: 134,
        type: EnumFields.STATE,
        dictKey: 'AR',
        content: 'Arkansas',
        description: null,
    },
    {
        id: 135,
        type: EnumFields.STATE,
        dictKey: 'CA',
        content: 'California',
        description: null,
    },
    {
        id: 136,
        type: EnumFields.STATE,
        dictKey: 'CO',
        content: 'Colorado',
        description: null,
    },
    {
        id: 137,
        type: EnumFields.STATE,
        dictKey: 'CT',
        content: 'Connecticut',
        description: null,
    },
    {
        id: 138,
        type: EnumFields.STATE,
        dictKey: 'DE',
        content: 'Delaware',
        description: null,
    },
    {
        id: 139,
        type: EnumFields.STATE,
        dictKey: 'DC',
        content: 'District of Columbia',
        description: null,
    },
    {
        id: 140,
        type: EnumFields.STATE,
        dictKey: 'FL',
        content: 'Florida',
        description: null,
    },
    {
        id: 141,
        type: EnumFields.STATE,
        dictKey: 'GA',
        content: 'Georgia',
        description: null,
    },
    {
        id: 142,
        type: EnumFields.STATE,
        dictKey: 'HI',
        content: 'Hawaii',
        description: null,
    },
    {
        id: 143,
        type: EnumFields.STATE,
        dictKey: 'ID',
        content: 'Idaho',
        description: null,
    },
    {
        id: 144,
        type: EnumFields.STATE,
        dictKey: 'IL',
        content: 'Illinois',
        description: null,
    },
    {
        id: 145,
        type: EnumFields.STATE,
        dictKey: 'IN',
        content: 'Indiana',
        description: null,
    },
    {
        id: 146,
        type: EnumFields.STATE,
        dictKey: 'IA',
        content: 'Iowa',
        description: null,
    },
    {
        id: 147,
        type: EnumFields.STATE,
        dictKey: 'KS',
        content: 'Kansas',
        description: null,
    },
    {
        id: 148,
        type: EnumFields.STATE,
        dictKey: 'KY',
        content: 'Kentucky',
        description: null,
    },
    {
        id: 149,
        type: EnumFields.STATE,
        dictKey: 'LA',
        content: 'Louisiana',
        description: null,
    },
    {
        id: 150,
        type: EnumFields.STATE,
        dictKey: 'ME',
        content: 'Maine',
        description: null,
    },
    {
        id: 151,
        type: EnumFields.STATE,
        dictKey: 'MD',
        content: 'Maryland',
        description: null,
    },
    {
        id: 152,
        type: EnumFields.STATE,
        dictKey: 'MA',
        content: 'Massachusetts',
        description: null,
    },
    {
        id: 153,
        type: EnumFields.STATE,
        dictKey: 'MI',
        content: 'Michigan',
        description: null,
    },
    {
        id: 154,
        type: EnumFields.STATE,
        dictKey: 'MN',
        content: 'Minnesota',
        description: null,
    },
    {
        id: 155,
        type: EnumFields.STATE,
        dictKey: 'MS',
        content: 'Mississippi',
        description: null,
    },
    {
        id: 156,
        type: EnumFields.STATE,
        dictKey: 'MO',
        content: 'Missouri',
        description: null,
    },
    {
        id: 157,
        type: EnumFields.STATE,
        dictKey: 'MT',
        content: 'Montana',
        description: null,
    },
    {
        id: 158,
        type: EnumFields.STATE,
        dictKey: 'NE',
        content: 'Nebraska',
        description: null,
    },
    {
        id: 159,
        type: EnumFields.STATE,
        dictKey: 'NV',
        content: 'Nevada',
        description: null,
    },
    {
        id: 160,
        type: EnumFields.STATE,
        dictKey: 'NH',
        content: 'New Hampshire',
        description: null,
    },
    {
        id: 161,
        type: EnumFields.STATE,
        dictKey: 'NJ',
        content: 'New Jersey',
        description: null,
    },
    {
        id: 162,
        type: EnumFields.STATE,
        dictKey: 'NM',
        content: 'New Mexico',
        description: null,
    },
    {
        id: 163,
        type: EnumFields.STATE,
        dictKey: 'NY',
        content: 'New York',
        description: null,
    },
    {
        id: 164,
        type: EnumFields.STATE,
        dictKey: 'NC',
        content: 'North Carolina',
        description: null,
    },
    {
        id: 165,
        type: EnumFields.STATE,
        dictKey: 'ND',
        content: 'North Dakota',
        description: null,
    },
    {
        id: 166,
        type: EnumFields.STATE,
        dictKey: 'OH',
        content: 'Ohio',
        description: null,
    },
    {
        id: 167,
        type: EnumFields.STATE,
        dictKey: 'OK',
        content: 'Oklahoma',
        description: null,
    },
    {
        id: 168,
        type: EnumFields.STATE,
        dictKey: 'OR',
        content: 'Oregon',
        description: null,
    },
    {
        id: 169,
        type: EnumFields.STATE,
        dictKey: 'PA',
        content: 'Pennsylvania',
        description: null,
    },
    {
        id: 170,
        type: EnumFields.STATE,
        dictKey: 'RI',
        content: 'Rhode Island',
        description: null,
    },
    {
        id: 171,
        type: EnumFields.STATE,
        dictKey: 'SC',
        content: 'South Carolina',
        description: null,
    },
    {
        id: 172,
        type: EnumFields.STATE,
        dictKey: 'SD',
        content: 'South Dakota',
        description: null,
    },
    {
        id: 173,
        type: EnumFields.STATE,
        dictKey: 'TN',
        content: 'Tennessee',
        description: null,
    },
    {
        id: 174,
        type: EnumFields.STATE,
        dictKey: 'TX',
        content: 'Texas',
        description: null,
    },
    {
        id: 175,
        type: EnumFields.STATE,
        dictKey: 'UT',
        content: 'Utah',
        description: null,
    },
    {
        id: 176,
        type: EnumFields.STATE,
        dictKey: 'VT',
        content: 'Vermont',
        description: null,
    },
    {
        id: 177,
        type: EnumFields.STATE,
        dictKey: 'VA',
        content: 'Virginia',
        description: null,
    },
    {
        id: 178,
        type: EnumFields.STATE,
        dictKey: 'WA',
        content: 'Washington',
        description: null,
    },
    {
        id: 179,
        type: EnumFields.STATE,
        dictKey: 'WV',
        content: 'West Virginia',
        description: null,
    },
    {
        id: 180,
        type: EnumFields.STATE,
        dictKey: 'WI',
        content: 'Wisconsin',
        description: null,
    },
    {
        id: 181,
        type: EnumFields.STATE,
        dictKey: 'WY',
        content: 'Wyoming',
        description: null,
    },
];

export enum ESpecialty {
    PSYCHIATRIC_MENTAL_HEALTH = 'Psychiatric & Mental Health',
    COUNSELING_THERAPY = 'Counseling & Therapy',
    WEIGHT_LOSS = 'Weight Loss',
    DERMATOLOGY = 'Dermatology',
    INFECTIONS = 'Infections',
    MENS_HEALTH = "Men's Health",
    WOMENS_HEALTH = "Women's Health",
    PREVENTIVE_PRIMARY_CARE = 'Preventive & Primary Care',
}

export const SPECIALTY_TIPS_MAP: Record<ESpecialty, { reminder: string; toolTips: string }> = {
    [ESpecialty.PSYCHIATRIC_MENTAL_HEALTH]: {
        reminder:
            'Input a condition treated or a treatment method. It’s encouraged to differentiate the price for different conditions depending on demand. For example, you could put “anxiety treatment” as one service and put “ADHD treatment” as another service. ',
        toolTips:
            'Input a condition treated or a treatment method. For example, anxiety treatment, ADHD treatment, etc.',
    },
    [ESpecialty.COUNSELING_THERAPY]: {
        reminder:
            'Input a condition treated or a treatment method. It’s encouraged to differentiate the price for different conditions depending on demand. For example, you could put “couple therapy” as one service and put “grief counseling” as another service. ',
        toolTips:
            'Input a condition treated or a treatment method. For example, couple therapy, grief counseling, etc.',
    },
    [ESpecialty.WEIGHT_LOSS]: {
        reminder:
            'Input a condition treated or a treatment method. It’s encouraged to differentiate the price for different conditions depending on demand. For example, you could put “weight loss medication treatment” as one service and put “lifestyle counseling” as another service. ',
        toolTips:
            'Input a condition treated or a treatment method. For example, weight loss medication treatment, lifestyle counseling, etc.',
    },
    [ESpecialty.DERMATOLOGY]: {
        reminder:
            'Input a condition treated or a treatment method. It’s encouraged to differentiate the price for different conditions depending on demand. For example, you could put “skin infection treatment” as one service and put “acne treatment” as another service. ',
        toolTips:
            'Input a condition treated or a treatment method. For example, skin infection treatment, acne treatment, etc.',
    },
    [ESpecialty.INFECTIONS]: {
        reminder:
            'Input a condition treated or a treatment method. It’s encouraged to differentiate the price for different conditions depending on demand. For example, you could put “yeast infection treatment” as one service and put “UTI treatment” as another service. ',
        toolTips:
            'Input a condition treated or a treatment method. For example, yeast infection treatment, UTI treatment, etc.',
    },
    [ESpecialty.MENS_HEALTH]: {
        reminder:
            'Input a condition treated or a treatment method. It’s encouraged to differentiate the price for different conditions depending on demand. For example, you could put “erectile dysfunction treatment” as one service and put “sexual health counseling” as another service. ',
        toolTips:
            'Input a condition treated or a treatment method. For example, erectile dysfunction treatment, sexual health counseling, etc.',
    },
    [ESpecialty.WOMENS_HEALTH]: {
        reminder:
            'Input a condition treated or a treatment method. It’s encouraged to differentiate the price for different conditions depending on demand. For example, you could put “infertility treatment” as one service and put “menopause treatment” as another service. ',
        toolTips:
            'Input a condition treated or a treatment method. For example, infertility treatment, menopause treatment etc.',
    },
    [ESpecialty.PREVENTIVE_PRIMARY_CARE]: {
        reminder:
            'Input a condition treated or a treatment method. It’s encouraged to differentiate the price for different conditions depending on demand. For example, you could put “routine check-ups” as one service and put “asthma treatment” as another service. ',
        toolTips:
            'Input a condition treated or a treatment method. For example, Covid-19 vaccination, asthma treatment, routine check-up, etc.',
    },
};

// 用来管理Booking link 的本地草稿版本用，不要轻易修改！！！
// 因为如果修改了，会导致删除掉localstorage内之前存的草稿
export const DRAFT_STORAGE_VERSION = 'v20250310';

export const SERVER_PRODUCT_ID_FE_TYPE_MAP: Record<string, EAddOnProductCode> = {};

export const IS_BACK_FROM_STRIPE = 'isBackFromStripe';

export const SHOW_KLARITY_ADVERTISING_ICON = 'showKlarityPlanAdvertisingIcon';

// 为了处理一进入页面的时候，stepInfo是空的，记录step只有点击next之后才会后端记录
export const UNLOCK_YOURY_KIWI_BENEFITS = 'unlockYourKiwiBenefits';

export const BOOK_PROGRAM_WEBINAR_LINK =
    'https://calendly.com/briana-cleveland-helloklarity/klarity-weight-loss-program-intro-webinar-1';

export const PROGRAM_YOUTUBE_LINK = 'https://www.youtube.com/@kiwi-health/shorts';

export const NOT_SUPPORT_PROGRAM_STATE = ['AK', 'AR', 'CT', 'IN', 'KY', 'LA', 'MI', 'MN', 'VT', 'WI'];

export const FIRST_TIME_UPLOAD_PROFILE_PHOTO = 'firstTimeUploadProfilePhoto';

export const VIDEO_UPLOAD_DEMO = 'https://www.youtube.com/@kiwi-health/shorts';

export const LA_FIRE_SPE_NAME = 'telehealth visit & prescription refill';

export const LA_FIRE_SERVICE_PRICE = 28;

const CALENDLY_LINK_COMMON = `https://calendly.com/kiwi_health/klarity-pay-per-appointment?month=${dayjs().format('YYYY-MM')}`;

export const CALENDLY_LINK = {
    KIWI_GROUP_PRICE_CONTACT_LINK: CALENDLY_LINK_COMMON,
    KLARITY_GROUP_PRICE_CONTACT_LINK: CALENDLY_LINK_COMMON,
    ONBOARD: CALENDLY_LINK_COMMON,
    BOOK_PROGRAM_WEBINAR_LINK: CALENDLY_LINK_COMMON,
    UNIPROFILE_IMPROVE: CALENDLY_LINK_COMMON,
    LEARN_ABOUT_UNIPROFILE: CALENDLY_LINK_COMMON,
    ONBOARDING: CALENDLY_LINK_COMMON,
    UNIPROFILE_OPTIMISATION: CALENDLY_LINK_COMMON,
    ACCOUNT_ACTIVATION: CALENDLY_LINK_COMMON,
    INTRODUCTION_TO_KIWI: CALENDLY_LINK_COMMON,
    KLARITY_ONBOARDING_HELP: `https://calendly.com/klarity-and-kiwi/klarity-go-live-next-steps-to-start-zd?month=${dayjs().add(1, 'days').format('YYYY-MM')}`,
    KLARITY_ONBOARDING_MEET_SUCCESS_MANAGER: `https://calendly.com/klarity-and-kiwi/klarity-go-live-next-steps-to-start-zd?month=${dayjs().add(1, 'days').format('YYYY-MM')}`,
    PRO_LISTINGS_SPECIALIST: `https://calendly.com/hello-klarity/pro-listing-informational-webinar?month=${dayjs().add(3, 'days').format('YYYY-MM')}`,
    FINANCIALS_SPECIALIST: `https://calendly.com/hello-klarity/paylater-webinar?month=${dayjs().add(3, 'days').format('YYYY-MM')}`,
    KLARITY_BILLING_WEBINAR: `https://calendly.com/klarity-and-kiwi/klarity-billing-webinar?month=${dayjs().add(1, 'days').format('YYYY-MM')}`,
};

export const ONBOARDING_WATCHED_INTRO_VIDEO = 'onboardingWatchedIntroVideo';

export const RESOURCE_CATEGORY: Meta[] = [
    {
        label: 'Policies & Compliance',
        value: 'Policies & Compliance',
    },
    {
        label: 'Training & Onboarding',
        value: 'Training & Onboarding',
    },
    {
        label: 'Practice Management & Growth',
        value: 'Practice Management & Growth',
    },
    {
        label: 'Technical Support & Troubleshooting',
        value: 'Technical Support & Troubleshooting',
    },
];

export const DEFAULT_CALENDAR_COLOR = '#1D86DB';

export const LA_WILD_FIRE_SPECIALTY_NAME = 'Telehealth visit & prescription refill';

export const ColorOptions = ['#1D86DB', '#009572', '#E3DDFF', '#F8F88F', '#333D96', '#FFE8B4', '#FCA5A5', '#B9FFFF'];

export const WEBSOCKET_DEV_URL = 'wss://ws.boxpractice.com';
export const WEBSOCKET_TEST_URL = 'wss://ws-test.boxpractice.com'; // Assuming test uses the same URL as production for now
// export const WEBSOCKET_DEV_URL = 'wss://p8v3kj1984.execute-api.ap-northeast-1.amazonaws.com/dev';
// export const WEBSOCKET_TEST_URL = "wss://zyhyz9sr9g.execute-api.ap-northeast-1.amazonaws.com/test";

export const WEBSOCKET_PROD_URL = 'wss://ws.helloklarity.com';

export const SCRIPSURE_DEV_URL = 'https://ssu.scriptsure.com';
export const SCRIPSURE_PROD_URL = 'https://app.scriptsure.com';

export const getScriptSureUrl = () => {
    if (isDevEnv() || isTestEnv()) {
        return SCRIPSURE_DEV_URL;
    }
    return SCRIPSURE_PROD_URL;
};

export const VALID_DOMAIN = ['boxpractice.com', 'kiwihealth.com', 'helloklarity.com'];

export const DISABLE_CHARGE_PATIENTS_POPUP = 'disableChargePatientsPopup';

export const DISABLE_PRACTICE_FRONT_BANNER = 'disablePracticeFrontBanner';

export const GOOGLE_MAPS_API_KEY = 'AIzaSyD3XZa9nf0ZIpzNuGHltvBoaM6gDlV63qw'; //AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg - demo , AIzaSyD3XZa9nf0ZIpzNuGHltvBoaM6gDlV63qw - klarity

export const BillingStatusTipsMapping: Partial<Record<EBillingStatus, string>> = {
    [EBillingStatus.CANCELED]: 'The payment or transaction has been canceled.',
    [EBillingStatus.BILLING_CANCELED]: 'The payment or transaction has been canceled.',
    [EBillingStatus.PATIENT_NOT_READY]:
        'Payment delayed because the patient has not completed necessary steps or provided required information. System will process again.',
    [EBillingStatus.PROVIDER_NOT_READY]:
        "Payment delayed because your practice hasn't completed necessary steps or provided required information. System will process again.",
    [EBillingStatus.PROCESSING]: 'Payment is currently being processed and will finalize shortly.',
    [EBillingStatus.SUCCEEDED]: 'Payment has been successfully completed.',
    [EBillingStatus.FAILED]: 'The payment attempt was unsuccessful due to an error or decline.',
    [EBillingStatus.REFUNDED]: 'Payment has been returned to the patient.',
    [EBillingStatus.REFUND_PROCESSING]: 'Refund is currently being processed and will finalize shortly.',
    [EBillingStatus.DISPUTE_OPEN]:
        'A patient has raised a dispute regarding a payment, and it is awaiting your review.',
    [EBillingStatus.DISPUTE_PROCESSING]: 'A payment dispute is currently under review by the payment provider.',
    [EBillingStatus.DISPUTE_WON]: "The dispute has been resolved in your practice's favor.",
    [EBillingStatus.DISPUTE_LOST]:
        "The dispute has been resolved in the patient's favor, and funds have been returned.",
    [EBillingStatus.PENDING]: 'The payment has been initiated and is awaiting completion.',
    [EBillingStatus.REFUND_FAILED]: 'The refund attempt was unsuccessful due to an error or decline.',
    [EBillingStatus.NOT_READY]:
        "Payment delayed because your practice hasn't completed necessary steps or provided required information. System will process again.",
};

export const WEIGHT_LOSS_15_MINS_TEMPLATE = 'partner-weight-loss-2025';

export const KLAIRTY_TEMPLATE_PRICE_MAP = {
    [WEIGHT_LOSS_15_MINS_TEMPLATE]: {
        duration: 15,
        patientCost: 49,
        myEarning: 29,
        platformFee: 20,
        marketingMarkUp: 0,
    },
};

export const BOT_ID = {
    PROVIDER_ONBOARDING: 'provider_onboarding',
    PROVIDER_WEBAPP: 'provider_webapp',
};

export const VITE_ZOOM_SDK_KEY_DEV = 'Z9tuQwFgvqVduOnmtshFIFPWJ7kzsBqQxH69';
export const VITE_ZOOM_SDK_KEY = 'Z9tuQwFgvqVduOnmtshFIFPWJ7kzsBqQxH69';

export const ZOOM_AUTO_REFRESH_INTERVAL = 5000;

export const MODE = {
    OPS_PREVIEW: 'ops-preview',
};

export enum EMenuKey {
    HOME = 'home',
    APPOINTMENT = 'appointment',
    CHANNELS = 'channels',
    PROSPECTS = 'prospects',
    CLIENTS = 'clients',
    PRACTICE_FRONT = 'practice-front',
    EHR = 'ehr',
    REPUTATION_MANAGEMENT = 'reputation-management',
    KLARITY_REVIEWS = 'klarity-reviews',
    KLARITY_ASSESSMENT = 'klarity-assessment',
    CALENDAR = 'calendar',
    INBOX = 'inbox',
    MARKETING = 'marketing',
    PROFILE = 'profile',
    TEXT_VISIT = 'text-visit',
    PRESCRIPTIONS = 'prescriptions',
    FINANCIALS = 'financials',
    EFAX = 'efax',
    PRACTICE_OVERVIEW = 'practice-overview',
    INSURANCE_BILLING = 'insurance-billing',
    CREDENTIALING = 'credentialing',
}

const ALL_ROLES = [
    'GROUP_OWNER',
    'GROUP_PROVIDER',
    'GROUP_ADMINISTRATIVE_ASSISTANT',
    'GROUP_CLINICAL_ASSISTANT',
    'GROUP_PRACTICE_MANAGER',
] as const;

export const MENU_PERMISSION_CONFIG: Record<string, readonly string[]> = {
    [EMenuKey.PRACTICE_OVERVIEW]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER'],
    [EMenuKey.HOME]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER', 'GROUP_PROVIDER'],
    [EMenuKey.INBOX]: ALL_ROLES,
    [EMenuKey.CALENDAR]: ALL_ROLES,
    [EMenuKey.CLIENTS]: ALL_ROLES,
    [EMenuKey.KLARITY_REVIEWS]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER', 'GROUP_PROVIDER', 'GROUP_CLINICAL_ASSISTANT'],
    [EMenuKey.TEXT_VISIT]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER', 'GROUP_PROVIDER', 'GROUP_CLINICAL_ASSISTANT'],
    [EMenuKey.PRESCRIPTIONS]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER', 'GROUP_PROVIDER', 'GROUP_CLINICAL_ASSISTANT'],
    [EMenuKey.MARKETING]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER', 'GROUP_PROVIDER'],
    [EMenuKey.EFAX]: ALL_ROLES,
    [EMenuKey.FINANCIALS]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER'],
    [EMenuKey.INSURANCE_BILLING]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER', 'GROUP_ADMINISTRATIVE_ASSISTANT'],
    // GROUP_PROVIDER 只读看自己的 panel 状态（banner / 签合同等仍只给 owner，见 CredentialingPage）
    [EMenuKey.CREDENTIALING]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER', 'GROUP_ADMINISTRATIVE_ASSISTANT', 'GROUP_PROVIDER'],
    [EMenuKey.PROFILE]: ALL_ROLES,
    [EMenuKey.EHR]: ['GROUP_OWNER', 'GROUP_PRACTICE_MANAGER'],
};
